export default __webpack_public_path__ + "static/media/banner.612e46eb.jpg";